import React, { useEffect, useState } from "react";
import "./karriere.css";
import { getCareers } from "../../Transformations/NewsList";

export default function Karriere() {
	const [careers, setCareers] = useState([]);

	useEffect(() => {
		const fetchData = async () => {
			const data = await getCareers();
			setCareers(data);
		};
		fetchData();
	}, []);
	return (
		<div className="career-page">
			<div className="career-sec">
				<h1>Karriere</h1>
				{careers.map((career, index) => {
					return (
						<div className="" key={index}>
							<p>
								{career.position}{" "}
								<a className="description-link" href={career.job_desc}>
									Stellenbeschreibung herunterladen
								</a>
							</p>
						</div>
					);
				})}
			</div>
			<aside className="contact-sec beratun_kontakt">
				<p>
					Haben Sie Fragen zum Thema Vakanzen oder möchten uns näher
					kennenlernen?
				</p>
				<a className="link-button" href="/kontakt">
					Kontaktieren Sie uns
				</a>
			</aside>
		</div>
	);
}
